// src/hooks/useExportInventory.js
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import InventoryService from "../../../services/InventoryService";
import {useInventoryStore} from "../../../store/useInventoryStore";
import { exportToExcel } from "../../../utils/exportToExcel";
import { buildExcelHeaders } from "../../../utils/inventory/inventoryExcel";



const extractErrorMessage = (error, fallback = "خطا در دریافت اطلاعات برای خروجی اکسل") => {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.detail ||
    error?.response?.data?.error ||
    fallback
  );
};

export const useExportInventory = () => {
  const selectedWarehouseId = useInventoryStore((state) => state.selectedWarehouseId);
  const appliedSearch = useInventoryStore((state) => state.appliedSearch);
  const ordering = useInventoryStore((state) => state.ordering);
  const isActive = useInventoryStore((state) => state.isActive);
  const dateFrom = useInventoryStore((state) => state.dateFrom);
  const dateTo = useInventoryStore((state) => state.dateTo);


  return useMutation({
    mutationKey: ["export-inventory"],
    mutationFn: async (overrideParams = {}) => {
      if (!selectedWarehouseId && !overrideParams.warehouseId) {
        throw new Error("لطفاً ابتدا انبار را انتخاب کنید");
      }

      return await InventoryService.exportExcel({
        warehouseId: overrideParams.warehouseId ?? selectedWarehouseId,
        search: overrideParams.search ?? appliedSearch,
        ordering: overrideParams.ordering ?? ordering,
        isActive: overrideParams.isActive ?? isActive,
        dateFrom: overrideParams.dateFrom ?? dateFrom,
        dateTo: overrideParams.dateTo ?? dateTo,
      });
    },

    onSuccess: (response, variables) => {
      const rows = response?.data || [];

      if (!response?.success || !rows.length) {
        toast.error("داده‌ای برای خروجی وجود ندارد");
        return;
      }

      const excelData = rows.map((item) => ({
        id: item.id ?? "",
        name: item.name ?? "",
        product_code: item.product_code ?? "",
        brand: item.brand ?? "",
        category: item.category ?? item.category_name ?? "",
        price: item.price ?? "",
        stock: item.stock ?? "",
        discount_percent: item.discount_percent ?? "",
        min_order: item.min_order ?? "",
        max_order: item.max_order ?? "",
        order_multiple: item.order_multiple ?? "",
        is_active: item.is_active ?? true,
        inventory_is_active: item.inventory_is_active ?? true,
      }));

      const warehouseId = variables?.warehouseId ?? selectedWarehouseId;

      exportToExcel(excelData, `inventory-warehouse-${warehouseId}`, {
        headers: buildExcelHeaders(),
      });

      toast.success("خروجی اکسل با موفقیت ایجاد شد");
    },

    onError: (error) => {
      toast.error(extractErrorMessage(error));
    },
  });
};


